import { gql } from '@urql/core';
import { createQueryKeys } from '@lukemorales/query-key-factory';

export const adsLibraryPreviewFeatureKeys = createQueryKeys('adsLibraryPreviewFeature', {
  header: ({ siteId }) => [
    {
      siteId,
    },
  ],
});

const adsLibraryPreviewHeaderDocument = gql`
  query AdsLibraryPreviewHeader($siteId: Int!) {
    adsLibraryPreviewHeader(siteId: $siteId) {
      connections {
        connectionId
        accountId
        platform
        oldestImportedDataAt
        lastEntitiesSyncedAt
        lastMetricsSyncedAt
        lastSyncedAt
        lastSyncedDate
      }
    }
  }
`;

export function adsLibraryPreviewHeaderQuery({ siteId }) {
  const variables = { siteId };

  return {
    ...adsLibraryPreviewFeatureKeys.header({ siteId }),
    enabled: Number.isFinite(siteId),
    useErrorBoundary: false,
    refetchOnWindowFocus: false,
    meta: {
      query: adsLibraryPreviewHeaderDocument,
      variables,
    },
  };
}
